import { includes } from 'lodash';
import { IOrganization } from 'src/common/models/organization';

export const hasFeature = (organization: IOrganization, feature: string) =>
  organization && includes(organization.features, feature);
